<div class="main">
    <div class="heading d-flex flex-dir-row just-space">
        <div class="d-flex flex-dir-col">
            <div class="d-flex just-space"><span class="h6-b">{{stopDetail.address}}</span><img *ngIf="false"
                    class="pointer-cursor" (click)="onClosePopup()" src="{{imgSrc}}assets/icons/cross-icon.svg" alt="">
            </div>
            <div class="d-flex gap-8">
                <span class="h8 grey-text">Planned: {{stopDetail.plannedArrivalTimeOfStop }}</span>
                <span class="h8 {{stopDetail.actualColorClass}}" *ngIf="stopDetail?.actualArrivalTimeOfStop !== 0">
                    Actual: {{stopDetail?.actualArrivalTimeOfStop}}
                </span>
                <span class="h8 {{stopDetail.actualColorClass}}" *ngIf="stopDetail?.actualArrivalTimeOfStop === 0">
                    Actual: --
                </span>
            </div>
        </div>
        <img src="{{imgSrc}}assets/icons/cross-icon.svg" style="cursor: pointer;" (click)="onClosePopup()" />

    </div>

    <div class="toggler d-flex">
        <div (click)="toggle('planned')"
            [ngClass]="{'activated':toggler=='planned','unactivated':toggler=='unPlannned'}"
            class="d-flex just-center align-center pointer-cursor width-50 planned"> <span>Planned Employees</span>
        </div>
        <div (click)="toggle('unPlanned')"
            [ngClass]="{'activated':toggler=='unPlanned','unactivated':toggler=='plannned'}"
            class="d-flex just-center align-center pointer-cursor width-50 unplanned"> <span>Unplanned Sign-Ins</span>
        </div>
    </div>


    <div *ngIf="toggler=='planned'" class="planned-details">

        <div *ngFor="let item of stopDetail.plannedEmployees,let i = index;" class="card d-flex just-space">
            <div class="card1 d-flex gap-8">
                <div>
                    <div [style.background-color]="colors[i % colors.length]"
                        class="employee-name-circle d-flex just-center align-center"><span class="h6-b">{{ item?.name[0]
                            }}</span></div>
                </div>
                <div class="d-flex flex-dir-col">
                    <span class="h7">{{item?.name}}</span>
                    <span class="h8 grey">{{item.employeeId}}</span>
                </div>
            </div>

            <div class="card2 d-flex flex-dir-col">
                <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                <span class="h8 grey">Signed In at</span>
            </div>

            <div class="card3">
                <span [style.color]="getShuttleStatus(item.empStatus).color" class="h8-b">
                    {{ getShuttleStatus(item.empStatus)?.name }}
                </span>
            </div>
        </div>
    </div>


    <div *ngIf="toggler=='unPlanned'" class="unplanned-details">

        <div *ngIf="stopDetail?.actualArrivalTimeOfStop != 0">
            <div *ngFor="let item of stopDetail.unplannedEmployees,let i = index;" class="card d-flex just-space">
                <div class="card1 d-flex gap-8">
                    <div>
                        <div [style.background-color]="colors[i % colors.length]"
                            class="employee-name-circle d-flex just-center align-center"><span class="h6-b">{{
                                item?.name[0] }}</span></div>
                    </div>
                    <div class="d-flex flex-dir-col">
                        <span class="h7">{{ item?.name}}</span>
                        <span class="h8 grey">{{ item.employeeId }}</span>
                    </div>
                </div>

                <div class="card2 d-flex flex-dir-col">
                    <span class="h7">{{getConvertedTimeZoneTime(item?.actualPickupTime)}}</span>
                    <span class="h8 grey">Signed In at</span>
                </div>

                <div class="card3">
                    <span *ngIf="getShuttleStatus(item.shuttleEmpSignInType)?.name === 'Different Sign In Location'"
                        class="h8-b" [style.color]="getShuttleStatus(item.shuttleEmpSignInType).color">
                        Different Planned Stop
                    </span>
                    <span *ngIf="getShuttleStatus(item.shuttleEmpSignInType)?.name !== 'Different Sign In Location'"
                        class="h8-b" [style.color]="getShuttleStatus(item.shuttleEmpSignInType).color">
                        {{ getShuttleStatus(item.shuttleEmpSignInType)?.name }}
                    </span>

                </div>
            </div>
        </div>

        <div class="no-employee-info" *ngIf="stopDetail?.actualArrivalTimeOfStop == 0 ">
            <img src="{{imgSrc}}assets/icons/employee-information-not-found.svg" alt="">
        </div>


    </div>



</div>